import {
    FETCH_CREATE_COMMONS_REQUEST,
    FETCH_CREATE_COMMONS_SUCCESS,
    FETCH_CREATE_COMMONS_FAILURE,
} from '../../actions/commons/create-common-action';

const initialState = {
    createdCommon: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const CreateCommonReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_CREATE_COMMONS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_CREATE_COMMONS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                createdCommon: { ...action.payload[0] },
            };
        case FETCH_CREATE_COMMONS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default CreateCommonReducer;